import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { combineLatest, firstValueFrom, from, map, Observable, switchMap, take, tap } from 'rxjs';
import { CvatTasks } from '../../../models/tasks_cvat';
import { Table } from 'primeng/table';
import { CvatTasksService } from '../../../services/cvat-tasks.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CvatProjectsService } from '../../../services/cvat-projects.service';
import { UsersService } from '../../../users/users.service';
import { MatCardModule } from '@angular/material/card';
import { state } from '@angular/animations';
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from '@angular/material/icon';
import { CvatProjects } from '../../../models/cvat-projects';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, PageEvent } from "@angular/material/paginator";;
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorIntlCro } from '../../library-objects/list-library-objects/paginator-intl';

@Component({
  selector: 'app-cvat-tasks',
  standalone: true,
  imports: [MainHeaderComponent, MatButtonModule, CommonModule, MatFormFieldModule, RouterModule, RouterLink, MatCardModule, MatExpansionModule, MatIconModule, MatSpinner, MatMenuModule, MatPaginator, MatInputModule, MatFormFieldModule, MatTooltipModule],
  providers:[{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro}],
  templateUrl: './cvat-tasks.component.html',
  styleUrl: './cvat-tasks.component.scss'
})
export class CvatTasksComponent {
  @ViewChild('stateTemplate', { static: true }) stateTemplate!: TemplateRef<any>;
  customTemplates: { [field: string]: TemplateRef<any> } = {};
  tasks$!: Observable<CvatTasks[]>
  selected!: CvatTasks[];
  projects!: CvatTasks[];
  selectedTasks: CvatTasks[] = [];
  selectedProjects: CvatProjects[] = [];
  selectedItems: any[] = [];
  project_id!: number;
  canDelete: boolean = false;
  titleheader: string = 'Tareas en el proyecto ';
  searchTerm: string = '';
  pageSize = 6;
  pageIndex = 0;
  totalRecords = 0;
  filteredTasks: CvatTasks[] = [];

  constructor(public cvatService: CvatTasksService, public cvatProject: CvatProjectsService, private _snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute, public userService: UsersService) { }

  ngOnInit(): void {
    console.log('🧠 Componente de tareas inicializado');
    this.userService.loadUsersStore();
    this.checkUserRoles();
    this.customTemplates = {
      state: this.stateTemplate
    };
    // this.tasks$ = this.cvatService.tasks$;
    this.project_id = +this.route.parent?.snapshot.paramMap.get('project_id')!;
    console.log('ID DEL PROYECTO', this.project_id)
    if (this.project_id) {
      this.loadLazyTasks();
    }
    console.log('Datos de tareas', this.tasks$)
  }


  loadLazyTasks(): void {
    const query = {
      page: this.pageIndex + 1,
      page_size: this.pageSize,
      search: this.searchTerm
    };

    combineLatest([
      this.cvatService.loadTasksLazy(this.project_id, query),
      this.cvatService.getStates$(this.project_id)
    ])
      .pipe(
        switchMap(async ([taskResponse, states]) => {
          this.totalRecords = taskResponse.count;
          const mappedTasks = await Promise.all(taskResponse.results.map(async (task) => {
            const match = states.find(state => +state.task_id === +task.id);
            const folder_name = match?.folder_name_bucket ?? null;
            let image_url: string | null = null;
            if (folder_name) {
              try {
                const urls = await firstValueFrom(this.cvatService.urlBucket(folder_name, 'cvat_pre_training'));
                image_url = urls.length > 0 ? urls[0] : null;
              } catch (error) {
                console.error('Error al obtener URL del bucket', error);
              }
            }
            return {
              ...task,
              state: match?.state ?? 'Sin anotaciones',
              process_id: match?.process_id,
              folder_name,
              image_url,
            };
          }));
          return mappedTasks;
        })
      )
      .subscribe((mappedTasks) => {
        this.filteredTasks = mappedTasks;
      });
  }
  

  onEditItem(item: any) {
    console.log('onEditItem items:', item);
    if(item.process_id){
      this.router.navigate(['/cvat', 'projects', item.project_id, 'tasks', 'annotations', item.id]);
    } else {
      this.router.navigate(['/cvat', 'projects', item.project_id, 'basic-tasks', item.id]);
    }
  }
  
  gotoAnnotations() {
    this.router.navigate(['/cvat', 'projects', this.project_id, 'tasks', 'annotations']);
  }
  
  gotoCreateBasicTask() {
    this.router.navigate(['/cvat', 'projects', this.project_id, 'basic-tasks']);
  }

  getStatusColor(status: string | undefined): string {
    const val = (status || '').toLowerCase();
    if (val === 'process') return 'status-process';
    if (val === 'finished') return 'status-finished';
    if (val === 'failed') return 'status-failed';
    return 'status-unknown';
  }

  onSelectionChange(event: any) {
    console.log('event', event)
    this.selectedTasks = event
  }

  onSearch(term: string): void {
    this.searchTerm = term;
    this.pageIndex = 0;
    this.loadLazyTasks();
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadLazyTasks();
  }

  checkUserRoles(): void {
    this.userService.getCurrentUserUid$().subscribe((uid) => {
      if (uid) {
        this.userService.users$.subscribe((users) => {
          const currentUser = users.find((user) => user.uid === uid);
          if (currentUser) {
            this.canDelete = currentUser.roles?.admin || currentUser.roles?.superadmin || false;
            console.log('Roles cargados:', currentUser.roles, 'Can Delete:', this.canDelete);
          } else {
            console.warn('Usuario no encontrado en la lista de usuarios.');
            this.canDelete = false;
          }
        });
      } else {
        console.error('No se pudo obtener el UID del usuario autenticado.');
        this.canDelete = false;
      }
    });
  }

  onDeleteItems(items: any) {
    if (!this.canDelete) {
      this._snackBar.open('No tienes permisos para eliminar esta tarea.', 'Cerrar', { duration: 3000 })
      return
    }
    console.log('ID DE LA TAREA', items.id)
    if (window.confirm("Esto eliminará esta tarea y todas sus configuraciones")) {
      this.cvatService.deleteTask(items.id).subscribe({
        next: () => {
          this.selectedTasks = [];
          this._snackBar.open(`Tarea ${items.id} eliminada.`, 'Ok', { duration: 3000 });
          // this.cvatService.loadTasksByProject(this.id);
        },
        error: (err: any) => {
          console.log('Error al eliminar la tarea', err)
        }
      })
    }
  }

  onRetryProcess(items: any) {
    if (items.state === 'Process') {
      this._snackBar.open(`No es posible reintentar este proceso, por favor espere que termine su ejecución.`, 'ok', { duration: 3000 })
      return
    }
    console.log('ITEM', items)
    console.log('ITEM', items.process_id)
    this.cvatService.retryProcess(items.process_id).subscribe({
      next: () => {
        this.selectedTasks = [];
        this._snackBar.open(`Proceso ${items.process_id} inicializado correctamente.`, 'ok', { duration: 3000 })
        // this.cvatService.loadTasksByProject(items.project_id)
      },
      error: (err: any) => {
        this._snackBar.open('No es posible reintentar proceso. Por favor crea una nueva anotación.', 'ok', { duration: 3000 })
      }
    })
  }

  onRowSelect(event: any) {
    console.log('select', this.selectedTasks)
  }

}
